import { render, staticRenderFns } from "./SharingTable.vue?vue&type=template&id=e68dfcb2&scoped=true&"
import script from "./SharingTable.vue?vue&type=script&lang=js&"
export * from "./SharingTable.vue?vue&type=script&lang=js&"
import style0 from "./SharingTable.vue?vue&type=style&index=0&id=e68dfcb2&scoped=true&lang=css&"
import style1 from "./SharingTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68dfcb2",
  null
  
)

export default component.exports